export default [
  {
    key: 'company',
    label: 'アライアンス名',
    value: '',
  },
  {
    key: 'email',
    label: 'メールアドレス',
    value: '',
  },
  {
    key: 'account_name',
    label: 'ユーザ名',
    value: '',
  },
  {
    key: 'gender',
    label: '性別',
    value: '',
  },
  {
    key: 'height',
    label: '身長',
    value: '',
  },
  {
    key: 'birthday',
    label: '年齢（生年月日)',
    value: '',
  },
  {
    key: 'goal_weight',
    label: '目標体重',
    value: '',
  },
  {
    key: 'athlete',
    label: 'アスリートモード',
    value: '',
  },
  {
    key: 'locale',
    label: '言語',
    value: '',
  },
  {
    key: 'app_version',
    label: 'アプリバージョン',
    value: '',
  },
  {
    key: 'platform',
    label: 'プラットフォーム',
    value: '',
  },
  {
    key: 'mobile_os',
    label: 'OSバージョン',
    value: '',
  },
  {
    key: 'cellphone_model',
    label: 'デバイス',
    value: '',
  },
  {
    key: 'created_at',
    label: '登録日時',
    value: '',
  },
  {
    key: 'updated_at',
    label: '更新日時',
    value: '',
  },
]
